import React from 'react';
import PropTypes from 'prop-types';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

const NavbarProductsMenu = ({
  options,
  onSelect,
  variant,
  isMobile,
  containerStyles,
}) => {
  const theme = useTheme();
  const titleColor = isMobile ? theme.palette.neutral.A500 : theme.palette.neutral.A800;
  return (
    <MenuList backgroundColor="white" sx={containerStyles}>
      {options.map((option) => (
        <MenuItem
          key={option.title}
          onClick={() => onSelect(option.url)}
          variant={variant}
        >
          <Stack spacing={1}>
            <Typography variant="small_3" fontWeight={700} color={titleColor}>
              {option.title.toUpperCase()}
            </Typography>
            {!isMobile && (
              <Typography variant="small_2" fontWeight={500} color={theme.palette.neutral.A500}>
                {option.subtitle}
              </Typography>
            )}
          </Stack>
        </MenuItem>
      ))}
    </MenuList>
  );
};

NavbarProductsMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    url: PropTypes.string.isRequired,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  containerStyles: PropTypes.shape({
    backgroundColor: PropTypes.string,
    padding: PropTypes.string,
    margin: PropTypes.string,
    borderRadius: PropTypes.string,
    boxShadow: PropTypes.string,
  }),
};
NavbarProductsMenu.defaultProps = {
  isMobile: false,
  containerStyles: {},
};

export default NavbarProductsMenu;
